<template>
  <div class="read">
    <div class="search">
      <van-search
        class="search-input"
        v-model="search"
        placeholder="请输入搜索关键词"
        @search="searchTap"
        @clear="searchTap"
      />
      <div class="search-address" @click=";(showPicker = true), buriedPoint()">
        <div class="search-address-text">{{ address ? address : '全部' }}</div>
        <van-icon name="play" />
      </div>
    </div>
    <van-list
      v-if="listShow"
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div class="list">
        <div
          class="list-wrap"
          v-for="item in list"
          :key="item.id"
          @click="readTap(item.id)"
        >
          <van-image class="list-wrap-img" :src="item.imageUrl" fit="cover" />
          <div class="list-wrap-tit">
            {{ item.assemblyName }}
          </div>
        </div>
      </div>
    </van-list>
    <van-empty
      v-if="!listShow"
      class="custom-image"
      :image="require('../../../assets/coupons-none.png')"
      description="暂无数据"
    />
    <van-popup v-model="showPicker" round position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        value-key="county"
        @cancel="showPicker = false"
        @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>
<script>
import { getArea } from '@api/lishui/live'
import { listAssemblyData } from '@api/reader/index'
import { Toast } from 'vant'
import { getToken } from '@utils'
import { newSaveRecord, newSaveUVRecord } from '@api/lishui'
import { getLocalStorage } from '@utils'
export default {
  data() {
    return {
      search: '',
      areaCode: '',
      address: '',
      showPicker: false,
      columns: [],
      list: [],
      listShow: true,
      loading: true,
      finished: false,
      pageNum: 1,
      pageSize: 20,
      userInfo: {}
    }
  },
  mounted() {
    if (getToken()) {
      this.getArea()
      this.getList()
    }
    this.userInfo = getLocalStorage('lishuiUserInfo')
      ? JSON.parse(getLocalStorage('lishuiUserInfo'))
      : {}
  },
  methods: {
    // 埋点
    buriedPoint() {
      const params = {
        applyName: this.$route.meta.title,
        creditCode: this.userInfo.creditCode,
        entName: this.userInfo.entName,
        mobile: this.userInfo.mobile
      }
      JSSDK_QYM.sendData({
        pageUrl: this.$route.path,
        pageId: window.location,
        pageName: this.$route.meta.title,
        userAgent: ''
      })
      newSaveRecord(params).then(res => { })
      newSaveUVRecord(params).then(res => { })
    },
    getArea() {
      getArea().then(res => {
        this.columns = [
          {
            code: '',
            county: '全部'
          },
          ...res.data.data
        ]
      })
    },
    getList(num) {
      if (num) {
        this.pageNum = 1
        this.list = []
        this.loading = true
        this.finished = false
        this.listShow = true
      }
      const params = {
        assemblyName: this.search,
        areaCode: this.areaCode,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      listAssemblyData(params).then(res => {
        const { code, data, msg } = res.data
        if (code === '0000') {
          data.results.forEach(item => {
            this.list.push(item)
          })
          this.loading = false
          if (data.results.length < this.pageSize) {
            this.finished = true
          } else {
            this.finished = false
          }
          if (this.list.length == 0) {
            this.listShow = false
          } else {
            this.listShow = true
          }
        } else {
          Toast(msg)
        }
      })
    },
    searchTap() {
      this.getList(1)
    },
    onConfirm(e) {
      this.areaCode = e.code
      this.address = e.county
      this.showPicker = false
      this.getList(1)
    },
    onLoad() {
      this.pageNum++
      this.getList()
    },
    readTap(id) {
      this.buriedPoint()
      this.$router.push({
        path: '/reader/details',
        query: {
          id: id
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.read {
  width: 100%;
  min-height: 100vh;
  background: url('../../../assets/imagess/policyBj.png');
  background-size: 100%;
}
/deep/.van-search {
  background-color: transparent;
}
.search {
  width: 100%;
  display: flex;
  background: #fff;
  position: sticky;
  top: 0;
  position: fixed;
  top: 0;
  z-index: 100;
  &-input {
    flex: 1;
    .van-search__content {
      border-radius: 40px;
    }
  }
  &-address {
    display: flex;
    align-items: center;
    padding: 0 10px;
    &-text {
      font-size: 14px;
    }
    .van-icon {
      color: #999;
      font-size: 14px;
      transform: rotate(90deg);
    }
  }
}
.list {
  margin-top: 50px;
  padding: 15px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 20px 15px;

  &-wrap {
    &-img {
      margin-bottom: 10px;
      width: 100%;
      height: 150px;
      position: relative;
    }
    &-img::after {
      content: '';
      width: 116%;
      height: 8px;
      background-color: rgba(208, 141, 83, 1);
      box-shadow: inset 0px -9px 5px 0px rgba(147, 83, 28, 1);
      position: absolute;
      bottom: -8px;
      left: -9px;
    }

    &-tit {
      width: 100px;
      height: 2.7em;
      font-size: 14px;
      color: #333;
      overflow: hidden; //超出的文本隐藏
      text-overflow: ellipsis; //溢出用省略号显示
      -webkit-line-clamp: 2; //规定行数
      overflow: hidden;
      // position: relative;
      // z-index: 10;
    }
  }
}
// .list-wrap:nth-child(3n) {
//   .list-wrap-img::after {
//     content: '';
//     width: 340%;
//     height: 8px;
//     background-color: rgba(208, 141, 83, 1);
//     box-shadow: inset 0px -9px 5px 0px rgba(147, 83, 28, 1);
//     position: absolute;
//     bottom: -8px;
//     left: -247px;
//   }
// }
.custom-image {
  margin-top: 30%;
  /deep/.van-empty__image {
    width: 200px;
    height: 120px;
  }
  /deep/.van-empty__description {
    margin-top: -36px;
  }
}
</style>
